<template>
  <div
    class="icon-hover"
    @mouseover="hovering = true"
    @mouseout="hovering = false"
  >
    <i-icon
      :symbol="symbol"
      :class="hovering ? 'i-text-neutral-90' : 'i-text-neutral-70'"
      :size="size"
    ></i-icon>
  </div>
</template>

<script>
import { iIcon } from '@inscribe/signal';
export default {
  components: { iIcon },
  props: {
    symbol: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: 20,
    },
  },
  data() {
    return {
      hovering: false,
    };
  },
};
</script>
